import { Action } from 'redux';
import { AdyenSession, PaymentMethod, SurchargeQuote } from 'types/PaymentMethod';

export const PAYMENT_METHODS_RESET = 'payment_methods/reset';

export const PAYMENT_METHODS_FETCH_START = 'payment_methods/fetch_start';
export const PAYMENT_METHODS_FETCH_SUCCESS = 'payment_methods/fetch_success';
export const PAYMENT_METHODS_FETCH_ERROR = 'payment_methods/fetch_error';

export const PAYMENT_METHODS_CREATE_SESSION_START = 'payment_methods/create_session_start';
export const PAYMENT_METHODS_CREATE_SESSION_SUCCESS = 'payment_methods/create_session_success';
export const PAYMENT_METHODS_CREATE_SESSION_ERROR = 'payment_methods/create_session_error';

export const PAYMENT_METHODS_SURCHARGE_QUOTE_START = 'payment_methods/surcharge_quote_start';
export const PAYMENT_METHODS_SURCHARGE_QUOTE_SUCCESS = 'payment_methods/surcharge_quote_success';
export const PAYMENT_METHODS_SURCHARGE_QUOTE_ERROR = 'payment_methods/surcharge_quote_error';
export const PAYMENT_METHODS_SURCHARGE_QUOTE_CLEAR = 'payment_methods/surcharge_quote_clear';

export const PAYMENT_METHODS_TOKEN_PAYMENT_START = 'payment_methods/token_payment_start';
export const PAYMENT_METHODS_TOKEN_PAYMENT_SUCCESS = 'payment_methods/token_payment_success';
export const PAYMENT_METHODS_TOKEN_PAYMENT_ERROR = 'payment_methods/token_payment_error';
export const PAYMENT_METHODS_TOKEN_PAYMENT_RESET = 'payment_methods/token_payment_reset';

interface PaymentMethodsResetAction extends Action<typeof PAYMENT_METHODS_RESET> {}

interface PaymentMethodsFetchStartAction extends Action<typeof PAYMENT_METHODS_FETCH_START> {}
interface PaymentMethodsFetchSuccessAction extends Action<typeof PAYMENT_METHODS_FETCH_SUCCESS> {
    payload: {
        paymentMethods: Array<PaymentMethod>;
    };
}
interface PaymentMethodsFetchErrorAction extends Action<typeof PAYMENT_METHODS_FETCH_ERROR> {}

interface PaymentMethodsCreateSessionStartAction
    extends Action<typeof PAYMENT_METHODS_CREATE_SESSION_START> {}
interface PaymentMethodsCreateSessionSuccessAction
    extends Action<typeof PAYMENT_METHODS_CREATE_SESSION_SUCCESS> {
    payload: {
        session: AdyenSession;
    };
}
interface PaymentMethodsCreateSessionErrorAction
    extends Action<typeof PAYMENT_METHODS_CREATE_SESSION_ERROR> {}

interface PaymentMethodsSurchargeQuoteStartAction
    extends Action<typeof PAYMENT_METHODS_SURCHARGE_QUOTE_START> {
    payload: {
        paymentMethodId: number;
    };
}
interface PaymentMethodsSurchargeQuoteSuccessAction
    extends Action<typeof PAYMENT_METHODS_SURCHARGE_QUOTE_SUCCESS> {
    payload: {
        quote: SurchargeQuote;
    };
}
interface PaymentMethodsSurchargeQuoteErrorAction
    extends Action<typeof PAYMENT_METHODS_SURCHARGE_QUOTE_ERROR> {}
interface PaymentMethodsSurchargeQuoteClearAction
    extends Action<typeof PAYMENT_METHODS_SURCHARGE_QUOTE_CLEAR> {}

interface PaymentMethodsTokenPaymentStartAction
    extends Action<typeof PAYMENT_METHODS_TOKEN_PAYMENT_START> {}
interface PaymentMethodsTokenPaymentSuccessAction
    extends Action<typeof PAYMENT_METHODS_TOKEN_PAYMENT_SUCCESS> {}
interface PaymentMethodsTokenPaymentErrorAction
    extends Action<typeof PAYMENT_METHODS_TOKEN_PAYMENT_ERROR> {}
interface PaymentMethodsTokenPaymentResetAction
    extends Action<typeof PAYMENT_METHODS_TOKEN_PAYMENT_RESET> {}

export type PaymentMethodsAction =
    | PaymentMethodsResetAction
    | PaymentMethodsFetchStartAction
    | PaymentMethodsFetchSuccessAction
    | PaymentMethodsFetchErrorAction
    | PaymentMethodsCreateSessionStartAction
    | PaymentMethodsCreateSessionSuccessAction
    | PaymentMethodsCreateSessionErrorAction
    | PaymentMethodsSurchargeQuoteStartAction
    | PaymentMethodsSurchargeQuoteSuccessAction
    | PaymentMethodsSurchargeQuoteErrorAction
    | PaymentMethodsSurchargeQuoteClearAction
    | PaymentMethodsTokenPaymentStartAction
    | PaymentMethodsTokenPaymentSuccessAction
    | PaymentMethodsTokenPaymentErrorAction
    | PaymentMethodsTokenPaymentResetAction;
